import { render, staticRenderFns } from "./ie.vue?vue&type=template&id=c408b3a0&lang=html&"
import script from "./ie.vue?vue&type=script&lang=js&"
export * from "./ie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ie.vue"
export default component.exports